import {useEffect, useRef, useState} from "react"

import Grid from '@material-ui/core/Grid'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import CircularProgress from '@material-ui/core/CircularProgress'

import Dialog from "@base/Dialog";
import Toast from "@base/Toast";

import EscolaService from '@services/EscolaService'

export const ListagemTratamentosDialog = (props) => {
  const processo = props.processo;
  
  const [cartao, setCartao] = useState("");
  const [tratamentos, setTratamentos] = useState([]);
  
  const [loading, setLoading] = useState(true);
  const toastRef = useRef(null);

  const limparEstado = () => {
    setCartao("");
    setTratamentos([]);
    setLoading(false);
  }

  useEffect(() => {
    if (props.id) {
      EscolaService.buscaDadosDoCartao(processo, props.id)
        .then(res => {
          const cartao = res.data;

          setCartao(cartao);

          const tratamentos = [];
          
          if (cartao.tratamentoNome) {
            cartao.tratamentoNome.nome = "Nome";
            tratamentos.push(cartao.tratamentoNome);
          }

          if (cartao.tratamentoNomeDuplicado) {
            cartao.tratamentoNomeDuplicado.nome = "Nome Duplicado";
            tratamentos.push(cartao.tratamentoNomeDuplicado);
          }

          if (cartao.tratamentoDataNascimento) {
            cartao.tratamentoDataNascimento.nome = "Data de Nascimento";
            tratamentos.push(cartao.tratamentoDataNascimento);
          }

          if (cartao.tratamentoCpf) {
            cartao.tratamentoCpf.nome = "CPF";
            tratamentos.push(cartao.tratamentoCpf);
          }

          setTratamentos([ ...tratamentos ]);
        })
        .catch(err => {
          toastRef.current.show("Não foi possível buscar os Dados de Tratamento do Cartão");
        })
        .finally(() => setLoading(false));
    }
  }, [processo, props.id]);

  return (
    <>
      <Toast ref={toastRef}/>
      <Dialog
        maxWidth={"md"}
        fullWidth={true}
        closeDialog={() => {
          limparEstado()
          props.handleClose();
        }}
        openDialog={props.open}
        title={`Listagem de Tratamentos para o Cartão ${cartao?.codigo}`}
      >
        <Grid container spacing={3}>
          <Grid item sm={12}>
            { loading ? 
              <CircularProgress style={{ margin: 'auto' }} />
            :
              <Table size='small' style={{ marginTop: 16 }} >
                <TableHead>
                  <TableRow>
                    <TableCell>Nome do Tratamento</TableCell>
                    <TableCell>Tipo de Tratamento</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Responsável</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tratamentos.length > 0 ? 
                    tratamentos.map((tratamento, index) => (
                      <TableRow key={index} hover>
                        <TableCell>{tratamento.nome}</TableCell>
                        <TableCell>{tratamento.tipoLabel ?? "--"}</TableCell>
                        <TableCell style={{ fontWeight: 'bold' }}>{tratamento.statusLabel ?? "--"}</TableCell>
                        <TableCell>{tratamento.responsavel ?? "--"}</TableCell>
                      </TableRow>
                    
                    ))
                  :
                    <>
                      <TableCell colSpan={4} align="center">Nenhum Tratamento Encontrado par Este Cartão</TableCell>
                    </>
                  }
                </TableBody>
              </Table>
            }
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
}

export default ListagemTratamentosDialog;
